import React from "react";
import { Collapse, Nav, NavItem, NavLink } from "reactstrap";
import Inventory from "assets/icon/gray-inv.svg";
import invontoryWhiteIcon from "../assets/icon/inventory-white-icon.svg";
import topWhiteArrow from "../assets/icon/top-white-arrow.svg";
import bottomPurpleArrow from "../assets/icon/bottom-purple-arrow.svg";
import cycleCount from "../assets/sidebar/cycle-count.svg";
import cycleCountP from "../assets/sidebar/cycle-countP.svg";

import optimization from "../assets/sidebar/opti.svg";
import optimizationP from "../assets/sidebar/opti-purple.svg";
import dashboardIconDark from "../assets/sidebar/dashboardIcon-dark.svg";
import dashboardIconLight from "../assets/sidebar/dashboardIcon-light.svg";
import productDark from "../assets/sidebar/productDark.svg";
import productLight from "../assets/sidebar/productLight.svg";
import purchaseOrderLight from "../assets/sidebar/purchaseOrderLight.svg";
import purchaseOrderDark from "../assets/sidebar/purchaseOrderDark.svg";
import { Link, useParams } from "react-router-dom";

const InventorySideBar = (props) => {
  const { title, toggles, activeText, setActiveText } = props;

  const handleClick = (link) => {
    setActiveText(link);
  };

  return (
    <NavItem className="">
      <NavLink
        to="/inventory-dashboard"
        className={`link-container ${
          location.pathname.startsWith("/inventory")
            ? "active-btn "
            : "nav-button"
        }`}
        onClick={toggles}
      >
        <span>
          <img
            src={
              location.pathname.startsWith("/inventory")
                ? invontoryWhiteIcon
                : Inventory
            }
          />{" "}
          <span
            className={
              location.pathname.startsWith("/inventory")
                ? "workflow-header"
                : "workflow-text"
            }
          >
            {title}
          </span>
        </span>
        <span className="work-flow-arrow">
          <img
            src={
              location.pathname.startsWith("/inventory")
                ? topWhiteArrow
                : bottomPurpleArrow
            }
          />
        </span>
      </NavLink>
      <Collapse isOpen={location.pathname.startsWith("/inventory")}>
        <Nav navbar vertical>
          <NavItem>
            <NavLink>
              <Link
                className="link-container"
                to="/inventory-dashboard"
                onClick={() => handleClick("/inventory-dashboard")}
                style={{
                  color: activeText === "/inventory-dashboard" ? "#542149" : "",
                }}
              >
                <div className="hoverFix workflow-text workflow-small ">
                  <div>
                    <img
                      className="workflow-icon"
                      src={
                        activeText == "/inventory-dashboard"
                          ? dashboardIconDark
                          : dashboardIconLight
                      }
                      alt=""
                    />
                    <span
                      style={{
                        fontWeight:
                          activeText == "/inventory-dashboard" ? "600" : "",
                      }}
                    >
                      Dashboard
                    </span>
                  </div>
                </div>
              </Link>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className="cont-main">
              <Link
                className="link-container"
                to="/inventory-products"
                onClick={() => handleClick("/inventory-products")}
                style={{
                  color: activeText === "/inventory-products" ? "#542149" : "",
                }}
              >
                <div className="hoverFix workflow-text workflow-small">
                  <div>
                    <img
                      className="workflow-icon"
                      src={
                        activeText == "/inventory-products"
                          ? productDark
                          : productLight
                      }
                      alt=""
                    />
                    <span
                      style={{
                        fontWeight:
                          activeText == "/inventory-products" ? "600" : "",
                      }}
                    >
                      Products
                    </span>
                  </div>
                </div>
              </Link>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink>
              <Link
                className="link-container"
                to="/inventory-purchase-order/tab-1"
                onClick={() => handleClick("/inventory-purchase-order/tab-1")}
                style={{
                  color: location.pathname.startsWith(
                    "/inventory-purchase-order/"
                  )
                    ? "#542149"
                    : "",
                }}
              >
                <div className="hoverFix workflow-text workflow-small">
                  <div>
                    <img
                      className="workflow-icon"
                      src={
                        location.pathname.startsWith(
                          "/inventory-purchase-order/"
                        )
                          ? purchaseOrderDark
                          : purchaseOrderLight
                      }
                      alt=""
                    />
                    <span
                      style={{
                        fontWeight: location.pathname.startsWith(
                          "/inventory-purchase-order/"
                        )
                          ? "600"
                          : "",
                      }}
                    >
                      Purchase Order
                    </span>
                  </div>
                  <div
                    style={{
                      fontWeight: location.pathname.startsWith(
                        "/inventory-purchase-order/"
                      )
                        ? "600"
                        : "",
                    }}
                  >
                    (103)
                  </div>
                </div>
              </Link>
            </NavLink>
          </NavItem>
          {/* <NavItem>
            <NavLink>
              <Link
                className="link-container"
                to="/inventory-optimization"
                onClick={() => handleClick("/inventory-optimization")}
                style={{
                  color:
                    activeText === "/inventory-optimization" ? "#542149" : "",
                }}
              >
                <div className="hoverFix workflow-text workflow-small">
                  <div>
                    <img
                      className="workflow-icon"
                      src={
                        activeText == "/inventory-optimization"
                          ? optimizationP
                          : optimization
                      }
                      alt=""
                    />
                    <span
                      style={{
                        fontWeight:
                          activeText == "/inventory-optimization" ? "600" : "",
                      }}
                    >
                      Optimization
                    </span>
                  </div>
                  <div className="workflow-text workflow-small"></div>
                </div>
              </Link>
            </NavLink>
          </NavItem> */}
          <NavItem>
            <NavLink>
              <Link
                className="link-container"
                to="/inventory-cyclecount"
                onClick={() => handleClick("/inventory-cyclecount")}
                style={{
                  color:
                    activeText === "/inventory-cyclecount" ? "#542149" : "",
                }}
              >
                <div className="hoverFix workflow-text workflow-small">
                  <div>
                    <img
                      className="workflow-icon"
                      src={
                        activeText == "/inventory-cyclecount"
                          ? cycleCountP
                          : cycleCount
                      }
                      alt=""
                    />
                    <span
                      style={{
                        fontWeight:
                          activeText == "/inventory-cyclecount" ? "600" : "",
                      }}
                    >
                      Cycle Counts
                    </span>
                  </div>
                  <div></div>
                </div>
              </Link>
            </NavLink>
          </NavItem>
        </Nav>
        <div className="sep"></div>
      </Collapse>
    </NavItem>
  );
};

export default InventorySideBar;
